module.exports = __webpack_public_path__ + "img/tk-back.8b6d7c42.png";